export interface ArticlePortraitData {
  name: string
  context: string
  headline: string
  description: string
  image: string
  alt: string
  position: string
  caption: string
  credit: string
  sourceUrl: string
  license: string
  licenseUrl: string
}

// Photo licenses and original descriptions were checked on September 8, 2026.
// Keep attribution beside every displayed portrait. The original files remain
// unaltered; responsive framing is handled by CSS and Next's image optimizer.
export const ARTICLE_PORTRAITS: Record<string, ArticlePortraitData> = {
  'jaden-smith-just-water-microplastics': {
    name: 'Jaden Smith',
    context: 'JUST Water · The packaging question',
    headline: 'Look beyond the carton.',
    description: 'A familiar founder makes the question worth asking. The materials and the testing tell the rest of the story.',
    image: '/blog/people/jaden-smith-web-summit-2019.jpg',
    alt: 'Jaden Smith speaking onstage in a black cap and hoodie at Web Summit in 2019',
    position: '50% 28%',
    caption: 'Jaden Smith at Web Summit, Lisbon, November 2019.',
    credit: 'Stephen McCarthy / Web Summit via Sportsfile',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:2019_-_Opening_Night_SM1_0368_(49015104751).jpg',
    license: 'CC BY 2.0',
    licenseUrl: 'https://creativecommons.org/licenses/by/2.0/',
  },
  'kourtney-kardashian-poosh-plastic-free-kitchen': {
    name: 'Kourtney Kardashian',
    context: 'Poosh · The everyday kitchen',
    headline: 'Start with tomorrow’s lunch.',
    description: 'Turn a beautifully organized kitchen into one practical change: the container you reach for every day.',
    image: '/blog/people/kourtney-kardashian-gq.png',
    alt: 'Kourtney Kardashian in a sunlit portrait from a GQ photoshoot',
    position: '62% 45%',
    caption: 'Kourtney Kardashian in a portrait from a GQ photoshoot, 2018.',
    credit: 'Britt Bellamy',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Kourtney_Kardashian_for_GQ_-_3.png',
    license: 'CC BY 3.0',
    licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
  },
  'bryan-johnson-microplastics-routine-sauna-evidence': {
    name: 'Bryan Johnson',
    context: 'Self-experiment · The evidence check',
    headline: 'Be curious. Read the method.',
    description: 'His public experiment opens a useful conversation about what a test measures—and which habits make sense to borrow.',
    image: '/blog/people/bryan-johnson-2026.jpg',
    alt: 'Bryan Johnson outdoors in a blue overshirt in 2026',
    position: '50% 25%',
    caption: 'Bryan Johnson, 2026.',
    credit: 'M Robertson',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Bryan_Johnson_2026.jpg',
    license: 'CC BY 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by/4.0/',
  },
  'jason-momoa-mananalu-water-microplastics': {
    name: 'Jason Momoa',
    context: 'Mananalu · A bottle’s next use',
    headline: 'Make the refill a habit.',
    description: 'The useful idea goes beyond a different bottle: plan where it gets filled, how it comes back, and what happens next.',
    image: '/blog/people/jason-momoa-comic-con-2018.jpg',
    alt: 'Jason Momoa at San Diego Comic-Con in 2018 wearing a purple shirt and necklaces',
    position: '50% 15%',
    caption: 'Jason Momoa at San Diego Comic-Con, July 2018.',
    credit: 'Gage Skidmore',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Jason_Momoa_by_Gage_Skidmore_2.jpg',
    license: 'CC BY-SA 3.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/3.0/',
  },
}
